import * as Redux from 'redux'

import {settings} from './CompareBuildsPage.slices'

export const compareBuildsPageReducers = Redux.combineReducers({
  settings: settings.reducer,
})
